import {
    IBookmarkListItem
} from '../../modules/room-reservation/components/room-reservation-bookmarks/room-reservation-bookmarks.component';
import { IRoomSearchForm } from 'src/app/modules/room-reservation/models/i-room-search-form';
import { IDeviceSearchForm } from 'src/app/modules/room-reservation/models/i-device-search-form';

export class ClientSettings {
    roomSearchComponent = new RoomSearchSettings();
}

export class SessionSettings {
    roomSearchForm: IRoomSearchForm;
    deviceSearchForm: IDeviceSearchForm;
}

export class RoomSearchSettings {
    infoTextCollapsed = false;
    searchBookmarks: IBookmarkListItem[] = [];
}
